var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg529EducationAccountsColoured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22557_14612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0161 14.2168C15.0155 14.2168 15.0148 14.2168 15.0142 14.2168C14.7966 14.2168 14.592 14.3016 14.4375 14.4557C14.2813 14.6115 14.1953 14.819 14.1953 15.0398V27.3813C14.1953 27.8339 14.5649 28.2029 15.0194 28.2041C16.9351 28.2087 20.1447 28.608 22.3589 30.9251V18.0094C22.3589 17.856 22.3198 17.7119 22.2458 17.5926C20.4285 14.666 16.9362 14.2213 15.0161 14.2168Z",
    fill: "#B48DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8037 27.3814V15.0398C31.8037 14.819 31.7177 14.6115 31.5615 14.4557C31.407 14.3016 31.2022 14.2168 30.9849 14.2168C30.9842 14.2168 30.9835 14.2168 30.9829 14.2168C29.0629 14.2214 25.5706 14.666 23.7532 17.5927C23.6792 17.712 23.6401 17.8561 23.6401 18.0095V30.9251C25.8543 28.608 29.064 28.2087 30.9797 28.2041C31.4341 28.2029 31.8037 27.8339 31.8037 27.3814Z",
    fill: "#B48DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6717 17.0566H33.075V27.375C33.075 28.5305 32.1335 29.4727 30.9762 29.4756C29.3513 29.4795 26.672 29.7972 24.7744 31.5932C28.0562 30.7896 31.5158 31.312 33.4875 31.7613C33.7337 31.8173 33.9881 31.7594 34.1853 31.6022C34.3819 31.4454 34.4946 31.211 34.4946 30.9594V17.8795C34.4947 17.4258 34.1255 17.0566 33.6717 17.0566Z",
    fill: "#B48DF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9197 27.375V17.0566H12.3229C11.8692 17.0566 11.5 17.4258 11.5 17.8795V30.9591C11.5 31.2108 11.6128 31.4452 11.8093 31.602C12.0064 31.7591 12.2606 31.8173 12.5071 31.761C14.4788 31.3117 17.9385 30.7894 21.2201 31.5929C19.3227 29.7971 16.6433 29.4794 15.0184 29.4755C13.8612 29.4727 12.9197 28.5305 12.9197 27.375Z",
    fill: "#B48DF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22557_14612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg529EducationAccountsColoured);
export default __webpack_public_path__ + "static/media/529_education_accounts_coloured.84e811a4cb436207c94916f477b48931.svg";
export { ForwardRef as ReactComponent };